import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// import 'lenis/dist/lenis.css' // Will be loaded dynamically
import { ThemeProvider } from "next-themes"

// Function to load CSS dynamically
const loadCss = (href: string) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.onload = () => console.log(`${href} loaded`);
  link.onerror = () => console.error(`Error loading ${href}`);
  document.head.appendChild(link);
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <App />
    </ThemeProvider>
  </StrictMode>
);

// Load non-critical CSS after initial render path
loadCss('lenis/dist/lenis.css');
